import { render } from "./budget.vue?vue&type=template&id=776fdcac&ts=true"
import script from "./budget.ts?vue&type=script&lang=ts&external"
export * from "./budget.ts?vue&type=script&lang=ts&external"

import "./budget.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__